// extracted by mini-css-extract-plugin
export var efficiency = "style-module--efficiency--c0537";
export var efficiency__contentText = "style-module--efficiency__content-text--1ab4b";
export var efficiency__title = "style-module--efficiency__title--46f31";
export var efficiency__videoText = "style-module--efficiency__video-text--5d062";
export var efficiency__videoWrapper = "style-module--efficiency__video-wrapper--e0f0c";
export var efficiency__wrapper = "style-module--efficiency__wrapper--e720e";
export var videoEnabled = "style-module--video--enabled--7cc09";
export var video__button = "style-module--video__button--0346b";
export var video__buttonIcon = "style-module--video__button-icon--6f431";
export var video__buttonShape = "style-module--video__button-shape--86da2";
export var video__link = "style-module--video__link--c3a47";
export var video__media = "style-module--video__media--6a0fa";